const commitments = [
  {
    title: "No facial recognition",
    body: "We do not run facial recognition on any image, anywhere on this platform. We will not introduce it.",
  },
  {
    title: "No hidden tracking",
    body: "We do not embed third-party trackers, analytics that profile you, or ad pixels.",
  },
  {
    title: "We do not sell personal data",
    body: "Personal data is not for sale and never will be. There is no data broker pipeline.",
  },
  {
    title: "Reports are reviewed before going public",
    body: "No raw report becomes a public alert. Trusted community verifiers and a platform admin review every submission, and remove personal details before publishing.",
  },
  {
    title: "Anonymous reporting is supported",
    body: "You can submit a report without your account being attached. We design every form to keep this option viable.",
  },
  {
    title: "Community safety over surveillance",
    body: "If a feature would harm community trust or expose people to over-policing, we don't build it — even if it's technically possible.",
  },
  {
    title: "Role-based access",
    body: "Who can see what is determined by your role. Public visitors see only the landing page. Members see approved alerts. Verifiers see queue items. Admins do governance.",
  },
];

export default function Privacy() {
  return (
    <div className="container-page py-16">
      <div className="mx-auto max-w-3xl">
        <h1 className="text-3xl font-semibold text-white md:text-4xl">
          Privacy & Trust
        </h1>
        <p className="mt-3 text-slate-300">
          Community Shield OS is built around community trust. These are
          commitments, not marketing language. They define what this platform
          is — and what it refuses to become.
        </p>

        <div className="mt-10 grid gap-5">
          {commitments.map((c) => (
            <div key={c.title} className="surface p-6">
              <h3 className="text-lg font-semibold text-white">{c.title}</h3>
              <p className="mt-2 text-slate-300">{c.body}</p>
            </div>
          ))}
        </div>

        <div className="surface-soft mt-10 p-6 text-sm text-slate-300">
          <p>
            If you ever feel that information about you is being handled in a
            way that violates these commitments, contact your platform admin.
            Community oversight is the point.
          </p>
        </div>
      </div>
    </div>
  );
}
